import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { DynamicFormModule } from "../dynamic-form/dynamic-form.module";
import { ViewAsComponent } from "./view-as.component";
import { ViewAsService } from "./view-as.service";
import { ViewAsModalComponent } from "./view-as-modal/view-as-modal.component";

@NgModule({
  declarations: [ViewAsComponent, ViewAsModalComponent],
  imports: [CoreModule, DynamicFormModule, DirectivesModule, PipesModule],
  exports: [ViewAsComponent],
  providers: [ViewAsService],
})
export class ViewAsModule {}
